export function WithDefaultValue(defaultValuePropKey: string): any {
  return function <TFunction extends Function>(
    classTarget: TFunction,
    propertyKey: string,
  ): TFunction {
    const myPropertyKey = `__WithoutDefaultValue__${propertyKey}`;
    Object.defineProperty(classTarget, propertyKey, {
      get: function (): any {
        return this[myPropertyKey] !== undefined ? this[myPropertyKey] : this[defaultValuePropKey];
      },
      set: function (v: any): void {
        this[myPropertyKey] = v;
      },
    });
    return classTarget;
  };
}
